import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface MovimentacaoJustificativaData {
  origemNome: string;
  destinoNome: string;
}

/** Tamanho mínimo da justificativa, o mesmo do cancelamento pelo menu. */
const TAMANHO_MINIMO_JUSTIFICATIVA = 3;

@Component({
  selector: 'app-movimentacao-justificativa-dialog',
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatTooltipModule],
  templateUrl: './movimentacao-justificativa-dialog.component.html',
  styleUrl: './movimentacao-justificativa-dialog.component.css',
})
export class MovimentacaoJustificativaDialogComponent {
  readonly tamanhoMinimo = TAMANHO_MINIMO_JUSTIFICATIVA;
  justificativa = '';

  constructor(
    public dialogRef: MatDialogRef<MovimentacaoJustificativaDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MovimentacaoJustificativaData,
  ) {}

  get valida(): boolean {
    return this.justificativa.trim().length >= TAMANHO_MINIMO_JUSTIFICATIVA;
  }

  confirmar(): void {
    if (this.valida) this.dialogRef.close(this.justificativa.trim());
  }

  cancelar(): void {
    this.dialogRef.close(null);
  }
}
